import { GalleryComponent2 } from "../Gallery/GalleryComponent2"
import { june2025Photos } from "../Gallery/LabPhotos/june2025/june2025Photos"

import "./LabText.scss"

export const June2025 = () => {
	return (
		<div className='june2025'>
			<h2 className='LabTitle'>maj - czerwiec</h2>
			<p className='LabText2'>
				W ramach projektu „Laboratoria przyszłości” uczniowie klas starszych
				zapoznali się z budową i obsługą lutownicy. Umiejętność jej obsługi
				przydaje się szczególnie osobom, które chcą i lubią samodzielnie
				konstruować, naprawiać i majsterkować, niektóre dzieci miały pierwszy
				raz możliwość zobaczenia tego narzędzia. Po omówieniu użytkowania
				lutownicy oraz podstawowych zasad BHP związanych w urządzeniem uczniowie
				przystąpili do zasadniczej części zajęć. Wykorzystując do pracy
				lutownicę, klej na gorąco oraz inne materiały.
			</p>
			<p className='LabText2'>
				Na zajęciach wykorzystaliśmy też zestawy Lego do budowania, które
				stwarzają dla uczniów nieograniczone możliwości kreatywnego
				projektowania gotowych bądź własnych pomysłów. Aparat fotograficzny oraz
				kamera zakupiona w ramach programu Laboratoria Przyszłości była
				wykorzystywana na zajęciach językowych do nagrywania scenek, które
				później były analizowane i oceniane.
			</p>
			<p className='LabText2'>
				Aparat fotograficzny, statyw, mikrofon kierunkowy, mikroport z
				akcesoriami, gimbał, zestaw oświetleniowy oraz kamera to nowoczesny
				sprzęt, który jest wykorzystywany w naszej szkole bardzo często do
				uwieczniania imprez i uroczystości klasowych i szkolnych, wycieczek
				klasowych, kiermaszów szkolnych, zajęć dodatkowych oraz dokumentowania
				życia Szkoły.
			</p>
			<GalleryComponent2 carouselId='june2025Photos' images={june2025Photos} />
		</div>
	)
}
